import { render, staticRenderFns } from "./TkImage.vue?vue&type=template&id=c9dbde0a&scoped=true&"
import script from "./TkImage.vue?vue&type=script&lang=js&"
export * from "./TkImage.vue?vue&type=script&lang=js&"
import style0 from "./TkImage.vue?vue&type=style&index=0&id=c9dbde0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dbde0a",
  null
  
)

export default component.exports